<style>
</style>

<template>
  <div>
    <apexchart
      :key="heatmapKey"
      v-if="series.length"
      type="heatmap"
      width="100%"
      height="100%"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>
<script>
const VueApexCharts = () => import("vue-apexcharts");
// import locations from "./data/location";
// import { generateData } from "./data/helper";

import { createNamespacedHelpers } from "vuex";
const orrNamespace = createNamespacedHelpers("orr");

// import { getLocationValues } from "./lib/api";

// const series = locations.map((item) => {
//   const result = {
//     name: item.location,
//     data: generateData(20, {
//       min: 0,
//       max: 90,
//     }),
//   };
//   return result;
// });

export default {
  props: ["HeatmapChart"],
  components: {
    apexchart: VueApexCharts,
  },
  computed: {
    ...orrNamespace.mapState({
      heatmapKey: (state) => state.heatmapKey,
      series: (state) => state.heatmapSeries,
      options: (state) => state.heatmapOptions,
    }),
  },
  methods: {
    ...orrNamespace.mapMutations([

    ]),
    ...orrNamespace.mapActions([
      'aLoadLocationValue',
    ]),
  },
  data() {
    return {
      // series,
      chartOptions: {
        chart: {
          height: 350,
          type: "heatmap",
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#008FFB"],
        title: {
          text: "HeatMap By Location",
        },
        yaxis: {
          labels: {
            offsetX: 70,
          },
        },
        xaxis: {
          type: 'category',
          categories: this.categories,
          labels: {},
          axisTicks: {},
        },
        grid: {
          padding: {
            left: 80, // or whatever value that works
            right: 10, // or whatever value that works
          },
        },
      },
    };
  },
  mounted() {
    this.aLoadLocationValue();
  }
};
</script>
